import React from 'react';
import { Drawer as BaseDrawer, DrawerProps as BaseDrawerProps } from 'antd';

export type DrawerProps = BaseDrawerProps & {};

const Drawer: React.FC<DrawerProps> = ({ ...props }) => <BaseDrawer {...props} />;

export default Drawer;

